"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getter_1 = require("./getter");
var decorator_1 = require("./decorator");
function stringOr(root, path, decorators, orElse) {
    if (path === void 0) { path = ''; }
    if (decorators === void 0) { decorators = []; }
    if (orElse === void 0) { orElse = ''; }
    var decorated = decorator_1.decorate(getter_1.getDefinedOrElse(root, path, orElse), decorators);
    return [].concat(decorated).map(function (possibleString) {
        return (typeof possibleString === 'object') ?
            JSON.stringify(possibleString) :
            String(possibleString);
    }).shift();
}
exports.stringOr = stringOr;
//# sourceMappingURL=stringOr.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/get-or/dist/getters/stringOr.js
 ** module id = 2477
 ** module chunks = 0
 **/